<template>
  <van-tabbar class="page-tabbar" safe-area-inset-bottom>
    <van-tabbar-item
            icon-prefix="icon"
            :icon="item.icon"
            :url="item.url"
            v-for="item in menuList"
            :key="item.icon"
            :badge="item.badge"
    >{{item.label}}
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
  import * as API from '@/api/shop';
  import {Tabbar, TabbarItem} from 'vant';

  export default {
	name: "Tabbar",
	props: {
	  preview: Boolean
	},
	components: {VanTabbar: Tabbar, VanTabbarItem: TabbarItem},
	data() {
	  return {
		cartCount: 0
	  };
	},
	computed: {
	  menuList() {
		const {bid} = this.$utils.param2Obj(location.href);
		const cateLink = this.$platform && this.$platform.categoryMode === 2 ? `/Shop/Goodscategory?bid=${bid}` : `/Shop/ShopList?levelidentity=-1&bid=${bid}`;

		return [
		  {icon: 'index_press', url: this.$IS_PREVIEW ? '' : '', label: "首页"},
		  {icon: 'category_moren', url: this.$IS_PREVIEW ? '' : cateLink, label: "类别"},
		  {icon: 'shop_unselected', url: this.$IS_PREVIEW ? '' : `/Shop/GoodsShopCar?bid=${bid}`, label: "购物车", badge: this.cartCount},
		  {icon: 'order_moren', url: this.$IS_PREVIEW ? '' : `/Shop/GoodsOrder?bid=${bid}`, label: "订单"},
		];
	  }
	},
	methods: {
	  async getCart() {
		const result = await API.getGoodsCart({});
		if (!result.success || !result.data.shopCartItems) return;
		this.cartCount = result.data.shopCartItems.reduce((p, it) => p + it.count, 0);
	  },
	  listenAddShopCart() {
		this.$pub && this.$pub.$on('add-shop-cart', () => {
		  this.getCart();
		});
	  }
	},
	watch: {},
	created() {
	  if (this.preview) return;
	  this.getCart();
	  this.listenAddShopCart();
	},
	mounted() {
	},
	beforeDestroy() {
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .page-tabbar {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .icon {
      font-family: "iconfont" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
</style>
